'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../../external/classnames/index.js');
var PropTypes = require('prop-types');
var useOutsideClick = require('../../../utilities/hooks/useOutsideClick.js');
var useMobileBool = require('../../../utilities/hooks/useMobileBool.js');
var magnifying_glass_inline = require('../../../assets/svg/magnifying_glass.inline.svg.js');
var close_inline = require('../../../assets/svg/close.inline.svg.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SearchBar = function SearchBar(props) {
  var className = props.className,
    active = props.active,
    setSearchIsActive = props.setSearchIsActive,
    open = props.open;
  var ref = React.useRef(null);
  var inputRef = React.useRef(null);
  var isMobile = useMobileBool.useMobileBool();
  var searchbarClasses = index.default('searchbar', className, 'lanl-searchbar', open || active ? 'lanl-searchbar--open' : '');
  React.useEffect(function () {
    active && inputRef.current ? inputRef.current.focus({
      preventScroll: true
    }) : null;
  });
  useOutsideClick.useOutsideClick(ref, function () {
    setSearchIsActive(false);
  });
  var handleSubmit = function handleSubmit(e) {
    var target = e.target,
      key = e.key;
    if (target.value && key === 'Enter') {
      window.location.replace("https://searcher-green.lanl.gov/webapps/LANL_External#/search?q=".concat(encodeURI(e.target.value)));
    }
  };
  return /*#__PURE__*/React__default.default.createElement(React__default.default.Fragment, null, /*#__PURE__*/React__default.default.createElement("div", {
    "data-testid": "lanl-searchbar",
    className: searchbarClasses,
    ref: ref
  }, /*#__PURE__*/React__default.default.createElement("button", {
    "aria-expanded": active,
    "aria-controls": "lanl-green-search".concat(isMobile ? '-mobile' : ''),
    "aria-label": "Open Search Input",
    "aria-hidden": isMobile || active ? true : false,
    className: "lanl-search-expand",
    disabled: active || isMobile,
    onClick: function onClick() {
      return !isMobile ? setSearchIsActive(true) : null;
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        setSearchIsActive(true);
      }
    }
  }, /*#__PURE__*/React__default.default.createElement(magnifying_glass_inline.default, {
    className: "lanl-search-icon"
  })), /*#__PURE__*/React__default.default.createElement("input", {
    id: "lanl-green-search".concat(isMobile ? '-mobile' : ''),
    disabled: !isMobile && !active,
    ref: inputRef,
    className: "lanl-input",
    placeholder: "Search",
    onKeyDown: function onKeyDown(e) {
      return handleSubmit(e);
    }
  }), !isMobile && active ? /*#__PURE__*/React__default.default.createElement("button", {
    "aria-expanded": active,
    "aria-controls": "lanl-green-search",
    "aria-label": "Close Search Input",
    "aria-hidden": !active ? true : false,
    className: "lanl-search-collapse",
    disabled: isMobile,
    onClick: function onClick(e) {
      e.stopPropagation();
      setSearchIsActive(false);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        setSearchIsActive(false);
      }
    }
  }, /*#__PURE__*/React__default.default.createElement(close_inline.default, {
    className: "lanl-close-icon"
  })) : null), /*#__PURE__*/React__default.default.createElement("div", {
    className: "lanl-searchbar-retainer"
  }));
};
SearchBar.defaultProps = {
  setSearchIsActive: function setSearchIsActive() {},
  open: false
};
SearchBar.propTypes = {
  active: PropTypes__default.default.bool,
  children: PropTypes__default.default.node,
  className: PropTypes__default.default.string,
  open: PropTypes__default.default.bool,
  setSearchIsActive: PropTypes__default.default.func
};

exports.SearchBar = SearchBar;
exports.default = SearchBar;
//# sourceMappingURL=SearchBar.js.map
